import React, { useRef, useState } from "react";
import "./photoUpload.css";
import ContentFile from "../../constants/contentFile.json";

const PhotoUpload = ({ onImageCapture, isSectionEnabled }) => {
  const fileInputRef = useRef(null);
  const Contents = ContentFile.gateInOutPage;

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleImageCapture = (event) => {
    const file = event.target.files[0];
    if (file) {
      onImageCapture(file);
    }
  };

  return (
    <div className={`uploadContainer ${isSectionEnabled ? "" : "disabled"}`}>
      <span className="uploadText">{Contents.photoUpload}</span>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept="image/*"
        capture="user"
        onChange={handleImageCapture}
      />
      <button
        className="uploadButton"
        onClick={handleUploadClick}
        disabled={!isSectionEnabled}
      >
        <span>{Contents.upload}</span>
      </button>
    </div>
  );
};

export default PhotoUpload;
